﻿import { Button, Checkbox, Textarea } from '@innovationnorway/cl-react';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { resources } from 'src/i18n';

type Props = {
  onSubmit: (comment?: string) => void;
  onClose?: () => void;
};

const AdditionalFeedback: React.FC<Props> = ({ onSubmit, onClose }) => {
  const { t: tCommon } = useTranslation('common');
  const { t: tOneWayIn } = useTranslation('oneWayIn');
  const [selected, setSelected] = useState<Array<string>>([]);
  const [comment, setComment] = useState<string>('');

  const handleCheckboxChange = (value: string) => {
    setSelected((prevSelected) => {
      const newSet = new Set(prevSelected);
      if (newSet.has(value)) {
        newSet.delete(value);
      } else {
        newSet.add(value);
      }
      return Array.from(newSet);
    });
  };

  const options = useMemo(() => {
    return checkBoxOptions.map((option) => ({
      value: tOneWayIn(option),
      text: tOneWayIn(option),
      selected: selected.includes(tOneWayIn(option)),
    }));
  }, [selected, tOneWayIn]);

  const showOtherComment = useMemo(
    () => selected.includes(tOneWayIn('opportunity.feedback.option.other')),
    [selected, tOneWayIn],
  );

  return (
    <div className="display--flex gap--1 flex-direction--column">
      <span className="font-size--large font-weight--bold">
        {tOneWayIn('opportunity.feedback.incorrect')}
      </span>
      {options.map((e, i) => (
        <Checkbox
          key={i}
          label={e.text}
          value={e.value}
          checked={e.selected}
          onChange={() => handleCheckboxChange(e.value)}
        />
      ))}
      {showOtherComment && (
        <Textarea
          rows={4}
          value={comment}
          placeholder={tCommon('writeHere')}
          aria-label={tOneWayIn('opportunity.feedback.wrongComment')}
          onChange={(e) => setComment(e.target.value)}
        />
      )}
      <div className="display--flex gap--2">
        <Button
          onClick={() => {
            const feedback = `${selected.join(', ')}${showOtherComment && comment.trim() ? ': ' + comment.trim() : ''}`;
            onSubmit(feedback || undefined);
          }}
          variant="primary"
        >
          {tCommon('send')}
        </Button>
        <Button onClick={onClose} variant="secondary">
          {tCommon('cancel')}
        </Button>
      </div>
    </div>
  );
};

export default AdditionalFeedback;

const checkBoxOptions: Array<keyof (typeof resources)['nb']['oneWayIn']> = [
  'opportunity.feedback.option.geography',
  'opportunity.feedback.option.tooFar',
  'opportunity.feedback.option.tooShort',
  'opportunity.feedback.option.notEnoughInnovation',
  'opportunity.feedback.option.wrongBusiness',
  'opportunity.feedback.option.other',
];
